module.exports = __webpack_public_path__ + "static/media/BL.03f3cd25.svg";